import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useBooking } from "@/context/BookingContext";

export default function CtaBand() {
  const { settings } = useSettings();
  const { openBooking } = useBooking();
  const label = settings.cta_label || "Design My Cashflow Now";

  return (
    <section data-testid="cta-band" className="relative z-10 border-t border-border overflow-hidden">
      <div className="bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-20 md:py-24 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
          <div>
            <p className="font-mono-accent text-xs uppercase tracking-[0.25em] mb-4 opacity-70">/ Start Today</p>
            <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl max-w-2xl">
              Ready to build your kingdom?
            </h2>
            <p className="mt-5 text-base sm:text-lg max-w-lg opacity-90">
              Book a free consultation and let's engineer a cashflow system built around your goals.
            </p>
          </div>
          <motion.button
            data-testid="cta-band-button"
            onClick={openBooking}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="shrink-0 group inline-flex items-center justify-center gap-3 bg-primary-foreground text-primary font-display font-black uppercase tracking-wide text-lg px-9 py-6 hover:opacity-90 transition-opacity"
          >
            {label}
            <ArrowUpRight size={22} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </motion.button>
        </div>
      </div>
    </section>
  );
}
